module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAM1BMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADbQS4qAAAAEHRSTlMAJKmt7fLxgIir8Bwb7CYl7G3t2wAAAIRJREFUSMft1t0KgCAMgFHNn7Ss9v5PG0WUslobdBGiV4XfAYcQKVXv6oOwBwjCXiT2XiCOni3OnimyniWKnj/H1orugQPG6K4oBwDOLDe9LaPy2SYEIlAAOgQcDYaXMam3Bhpo4GvA2Psh8EAu/JkxNIgIzBPVW40PmrrHU/moq/qnWAFCzB7Cu7cFNgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon3.png
// module id = akCb
// module chunks = 0